import { SettingsSection } from "./SettingsSection";

/**
 * ROW 4 — "The rules my sends obey" (D-206-010 row 4, kept READ-ONLY).
 *
 * **Who does what:** the person reads the rules every email he sends obeys; he does not switch them
 * off, because they are not preferences — they are what keeps his domains and his name in good
 * standing with the people he writes to.
 * **What he sees:** the rules in plain words, and where the verdict on any single email lives.
 * **What he feels:** *"never compliance-exposed… compliant by structure"* — Sam's W5 want. A rule
 * that is enforced FOR him is reassuring; a rule he could turn off would be a decision he is not
 * equipped to make, and the section says so instead of showing a greyed-out switch.
 *
 * WHY THERE IS NO CONTROL — AND WHY THAT IS THE HONEST DESIGN, NOT A MISSING FEATURE: the verdict is
 * **derived per message and never stored** (P133 D-133-024), and the registry that produces it is
 * not a per-person setting. Rendering a switch here would either save nothing (forbidden by
 * D-206-001) or imply a person may send without the check. The section therefore states the rules
 * and links to the page where the check on a real email is visible.
 *
 * ⚠️ NO COUNT AND NO RULE LIST IS FABRICATED HERE. The wording says what is checked (the sending
 * identity, the postal address the footer carries, the recipient's own rules) because those are the
 * facts the send path implements; it deliberately claims no number of rules, because no route on
 * this page was read that would support one.
 *
 * ⚠️ THE GATE CAUGHT THIS ROW'S OWN COPY, AND THAT IS WORTH RECORDING. The first draft ended *"…and
 * cannot be switched off"* — and the psychology gate (RULES_NAMING §6, run as a grep over the
 * rendered page by `probe_user_settings.mjs`) flagged the forbidden word `cannot` on the built page.
 * The fix is not a synonym hunt: the same fact is true and reads better as *"it stays on"*, which
 * states what the check IS instead of what the person may not do about it. §6 check 4 governs — the
 * content stays accurate and the wording carries it positively.
 */
export const SendRulesSection = () => (
  <SettingsSection
    title="The rules my sends obey"
    hint="What Raisy checks before anything of yours leaves, and where you can see the verdict on one email."
    value={
      <span className="font-normal">
        Every send is checked before it goes: that it comes from a mailbox you connected, that it
        carries the identity and postal address a business email must carry, and that the person
        receiving it is not on a list that must not be written to. The check runs for you on every
        email and stays on — it is what protects your name and your domain.
      </span>
    }
    link={{ to: "/compliance", label: "See the check on a real email" }}
  />
);
